import '@formatjs/intl-getcanonicallocales/polyfill';
import '@formatjs/intl-locale/polyfill';

import { shouldPolyfill as shouldPolyfillPluralRules } from '@formatjs/intl-pluralrules/should-polyfill';

import { shouldPolyfill as shouldPolyfillNumberFormat } from '@formatjs/intl-numberformat/should-polyfill';

import { Locale } from '../../integrations/locale/locale';

const locale = Locale.getLang();

const polyfillPluralRules = async () => {
    if (shouldPolyfillPluralRules()) {
        await import('@formatjs/intl-pluralrules/polyfill');
    }

    // @ts-ignore
    if ((<any>(Intl.PluralRules)).polyfilled) {
        switch (locale) {
        case 'pt':
            // @ts-ignore
            await import('@formatjs/intl-pluralrules/locale-data/pt');
            break;
        case 'es':
            // @ts-ignore
            await import('@formatjs/intl-pluralrules/locale-data/es');
            break;
        case 'en':
        default:
            // @ts-ignore
            await import('@formatjs/intl-pluralrules/locale-data/en');
        }
    }
};

const polyfillNumberFormat = async () => {
    if (shouldPolyfillNumberFormat()) {
        await import('@formatjs/intl-numberformat/polyfill');
    }

    if ((<any>(Intl.NumberFormat)).polyfilled) {
        switch (locale) {
        case 'pt':
            // @ts-ignore
            await import('@formatjs/intl-numberformat/locale-data/pt');
            break;
        case 'es':
            // @ts-ignore
            await import('@formatjs/intl-numberformat/locale-data/es');
            break;
        case 'en':
        default:
            // @ts-ignore
            await import('@formatjs/intl-numberformat/locale-data/en');
        }
    }
};

export const polyfill = async () => {
    await polyfillPluralRules();
    await polyfillNumberFormat();
};
